import type { FooterProps } from "./interface";

export function Footer({ children }: FooterProps) {
    return <footer className="mt-auto bg-white p-4 border-t border-gray-200"> {children} </footer>;
}